import React, { useState } from 'react';
import ArrowDown from '../../assets/icons/common/chevron-down.svg';
import ArrowUp from '../../assets/icons/common/chevron-up-active.svg';
import { FormattedMessage } from 'react-intl';

const MesColumnToggleButton = ({ columns, visibleColumns, toggleColumn }) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const handleCheckboxChange = (columnId) => {
    toggleColumn(columnId);
  };

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const specialColumns = ['checkbox', 'expander', 'actions', 'viewReceivers'];

  return (
    <div className="btn-group" style={{ position: 'static' }}>
      <button
        type="button"
        className="btn btn-left d-flex align-items-center"
        data-bs-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded={isDropdownOpen}
        style={{ borderTopRightRadius: '0.375rem', borderBottomRightRadius: '0.375rem' }}
        onClick={toggleDropdown}
      >
        <FormattedMessage id="EDIT_COLUMNS" />
        <img
          src={isDropdownOpen ? ArrowUp : ArrowDown}
          alt="Dropdown Arrow"
        />
      </button>
      <div
        className="dropdown-menu mes-dropdown-menu"
        aria-labelledby="btnGroupDrop1"
      >
        <ul className="list-group">
          {columns
            .filter((column) => !specialColumns.includes(column.id)) // Filter out special columns
            .map((column) => (
              <li className="list-group-item " key={column.id} >
                <input
                  className="form-check-input"
                  type="checkbox"
                  checked={visibleColumns.includes(column.id)}
                  onChange={() => handleCheckboxChange(column.id)}
                />
                <label className="form-check-label"><FormattedMessage id={column.Header} /></label>
              </li>
            ))}
        </ul>
      </div>
    </div>
  );
};

export default MesColumnToggleButton;